// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1OOyx","log":"ModalInventoryLogs_log__-8--L","date":"ModalInventoryLogs_date__3V5vr","userName":"ModalInventoryLogs_userName__1uVS0"};